import * as api from './apiInstance';
import * as metrics from './metrics';

export function configure(config: api.ApiConfig): void {
  api.configure(config);
  metrics.setupMetricTracking(config);
}
